import HttpService from "@/utils/httpData"
import * as axios from 'axios';
import { APP_CONFIG } from '@/utils/constants'
export const saveTeacherDocumentClassSchool = params => {
    let apiEndpoint = `TeacherDocumentClassSchool/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getDetail = id => {
    let apiEndpoint = `TeacherDocumentClassSchool/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const downloadFile = (data) => {
    let self = this
    let fullPath = `${APP_CONFIG.apiUrl}api/FileClassSchool/DownloadFile`
    return axios({
        url: fullPath,
        method: 'POST',
        data: data,
        responseType: 'blob'
    }).then((response) => {
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', data.fileName); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        return response
    })
        .catch(err => console.log(err))
        .finally(res => {
            return res
        })
}
